// von Lauersdorf — Bedienhelfer, übernommen aus prototyp/js/prototyp.js.
// Formulare werden hier wirklich versendet (Shopify); die Prüfung läuft vorher.

// Weiches Scrollen zu Ankern erst, wenn die Seite steht (s. atelier.css)
window.addEventListener('load', () => requestAnimationFrame(() => document.documentElement.classList.add('weich')));

// Menü: schließt nach der Wahl eines Punkts und auf Esc
const menue = document.querySelector('.menue');
if (menue) {
  menue.addEventListener('click', (ereignis) => {
    if (ereignis.target.closest('a')) menue.open = false;
  });
  document.addEventListener('keydown', (ereignis) => {
    if (ereignis.key === 'Escape' && menue.open) {
      menue.open = false;
      menue.querySelector('summary').focus();
    }
  });
  // Solange das Menü offen ist, ruht der Rest der Seite: kein Tabulator
  // hinter die Fläche, kein Vorlesen des Hintergrunds
  const hintergrund = document.querySelectorAll('main, footer, .kaufbalken, .entwurf');
  menue.addEventListener('toggle', () => hintergrund.forEach((teil) => { teil.inert = menue.open; }));
  // Safari stellt nach „Zurück" die Seite mit offenem Menü wieder her
  window.addEventListener('pageshow', (ereignis) => {
    if (ereignis.persisted) menue.open = false;
  });
  // Ab 68rem gibt es das Klappmenü nicht mehr: ein offenes darf nichts sperren
  matchMedia('(min-width: 68rem)').addEventListener('change', (ereignis) => {
    if (ereignis.matches) menue.open = false;
  });
}


// Beratungsanfrage: eigene Fehlermeldungen statt der Sprechblase des
// Browsers, Bestätigung an Ort und Stelle (Prototyp, ohne Versand)
const texte = window.atelierText || {};
const meldung = (feld) => {
  if (feld.validity.valueMissing) {
    return feld.type === 'email' ? texte.mailFehlt : texte.nameFehlt;
  }
  return texte.mailPruefen;
};
const pruefen = (feld) => {
  feld.value = feld.value.trim();
  const gueltig = feld.checkValidity();
  feld.setAttribute('aria-invalid', String(!gueltig));
  const fehlertext = document.getElementById(`${feld.id}-fehler`);
  if (fehlertext && !gueltig) fehlertext.textContent = meldung(feld);
  return gueltig;
};
document.querySelectorAll('[data-anfrage]').forEach((formular) => {
  const pflicht = formular.querySelectorAll('[required]');
  pflicht.forEach((feld) => {
    feld.addEventListener('blur', () => pruefen(feld));
    feld.addEventListener('input', () => {
      if (feld.getAttribute('aria-invalid') === 'true') pruefen(feld);
    });
  });
  formular.addEventListener('submit', (ereignis) => {
    const fehlerhaft = [...pflicht].filter((feld) => !pruefen(feld));
    if (fehlerhaft.length) {
      ereignis.preventDefault();
      fehlerhaft[0].focus();
    }
  });
});


document.querySelectorAll('[data-brief]').forEach((formular) => {
  // Gezielt das E-Mail-Feld: Shopify setzt versteckte Felder (form_type, utf8) an den Anfang des Formulars
  const feld = formular.querySelector('input[type="email"]');
  const fehler = formular.querySelector('.fuss__fehler');
  if (!feld || !fehler) return;
  formular.noValidate = true; // eigene Fehlermeldung statt Browser-Sprechblase, wie bei der Anfrage
  formular.addEventListener('submit', (ereignis) => {
    feld.value = feld.value.trim();
    const gueltig = feld.checkValidity() && /.+@.+\..+/.test(feld.value);
    feld.setAttribute('aria-invalid', String(!gueltig));
    fehler.hidden = gueltig;
    if (!gueltig) {
      ereignis.preventDefault();
      feld.focus();
    }
  });
});


// Verweise auf die Anfrage öffnen den Klappbereich in der Kaufspalte
const rat = document.querySelector('.rat');
if (rat) {
  const klappknopf = rat.querySelector('summary');
  rat.addEventListener('toggle', () => {
    klappknopf.textContent = rat.open ? texte.anfrageSchliessen : texte.beratungAnfragen;
  });
  // Öffnen per Verweis (#anfrage), nach dem Absenden (Shopify leitet mit
  // contact_posted=true und dem Anker des Formulars zurück) und wenn der
  // Dank oder eine Servermeldung gerendert wurde.
  // Nicht nach „Wieder da“: Shopify meldet den Erfolg allen Kontaktformularen der Seite, nur der Anker unterscheidet
  if (location.hash !== '#wieder-da-formular' && (location.hash === '#anfrage' || location.hash === '#anfrage-formular'
      || location.search.includes('contact_posted=true')
      || rat.querySelector('.anfrage__dank, .anfrage__server'))) rat.open = true;
  document.querySelectorAll('a[href="#anfrage"]').forEach((verweis) => {
    verweis.addEventListener('click', (ereignis) => {
      ereignis.preventDefault();
      rat.open = true;
      rat.scrollIntoView({ block: 'start' });
      rat.querySelector('input:not([type="hidden"])').focus({ preventScroll: true });
    });
  });
}

// ---------- Produktseite: Ausführung und „Wieder da“
// Ausverkaufte Ausführungen lassen sich wählen: Dann ist der Kaufknopf aus und das Formular erscheint
// mit der gewählten Ausführung. Kein Neuladen, denn Shopify leitet nach dem Absenden ohne ?variant= zurück.
const wiederDa = document.querySelector('.wieder-da');
const variantenwahl = document.querySelector('#kauf-variante');
if (variantenwahl) {
  const kaufknopf = document.querySelector('#kaufen button[type="submit"]');
  const balkenknopf = document.querySelector('.kaufbalken button');
  const dienste = document.querySelector('.kauf__dienste');
  const express = document.querySelector('.kauf__express');
  variantenwahl.addEventListener('change', () => {
    const option = variantenwahl.selectedOptions[0];
    const frei = option.dataset.frei === 'true';
    kaufknopf.disabled = !frei;
    kaufknopf.textContent = frei ? kaufknopf.dataset.kaufen : kaufknopf.dataset.aus;
    if (balkenknopf) balkenknopf.disabled = !frei;
    if (dienste) dienste.hidden = !frei;
    if (express) express.hidden = !frei;
    if (wiederDa) {
      wiederDa.hidden = frei;
      wiederDa.querySelector('[name="contact[artikel]"]').value = option.dataset.artikel;
    }
  });
}
if (wiederDa && location.search.includes('contact_posted=true') && location.hash === '#wieder-da-formular') {
  wiederDa.hidden = false;
  const dank = wiederDa.querySelector('.anfrage__dank');
  [...dank.parentElement.children].forEach((teil) => { teil.hidden = teil !== dank; });
  dank.focus();
}

// ---------- Kollektionsseite
// Sortierung greift sofort; der Knopf bleibt nur ohne Skript sichtbar
const sortierung = document.querySelector('.sortierung');
if (sortierung) {
  sortierung.querySelector('button').hidden = true;
  sortierung.querySelector('select').addEventListener('change', () => sortierung.submit());
}

// ---------- Produktseite
// Galerie mit Vorschaubildern: Ein Klick stellt die Aufnahme ein, Wischen markiert die passende Vorschau
const galerie = document.querySelector('.produkt__bilder');
const vorschau = document.querySelector('.vorschau');
if (galerie && vorschau) {
  // Gezählt werden die Verweise, nicht <picture>: Shopify-Produktbilder kommen als schlichtes <img>
  const bilder = [...galerie.querySelectorAll('.galerie__bild')];
  const knoepfe = [...vorschau.querySelectorAll('.vorschau__bild')];
  const weich = matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth';
  knoepfe.forEach((knopf, nummer) => {
    knopf.addEventListener('click', () => galerie.scrollTo({ left: nummer * galerie.clientWidth, behavior: weich }));
  });
  let gezeigt = -1;
  const zeigen = () => {
    const nummer = Math.min(Math.round(galerie.scrollLeft / galerie.clientWidth), bilder.length - 1);
    if (nummer === gezeigt) return;
    gezeigt = nummer;
    knoepfe.forEach((knopf, k) => knopf.setAttribute('aria-current', String(k === nummer)));
    // Per Tab erreichbar ist nur das sichtbare Bild; die übrigen über die Vorschaubilder
    bilder.forEach((bild, k) => { if (bild.tagName === 'A') bild.tabIndex = k === nummer ? 0 : -1; });
  };
  // Platz unter dem Bild für Vorschau und Kaufleiste (CSS --unter), damit alles im ersten Bildschirm
  // steht. Mehr Zeilen machen das Bild schmaler, ein schmaleres Bild nie weniger Zeilen: Nach
  // wenigen Runden steht der Wert fest.
  const rahmen = vorschau.parentElement;
  const leiste = document.querySelector('.kaufbalken');
  const platzMessen = () => {
    for (let runde = 0; runde < 4; runde++) {
      const unter = `${vorschau.offsetHeight + (leiste ? leiste.offsetHeight : 0)}px`;
      if (rahmen.style.getPropertyValue('--unter') === unter) break;
      rahmen.style.setProperty('--unter', unter);
    }
  };
  // Tastaturhalt nur, solange die Galerie seitlich scrollt (bei nur einer Aufnahme nicht)
  const haltSetzen = () => (galerie.scrollWidth > galerie.clientWidth ? galerie.setAttribute('tabindex', '0') : galerie.removeAttribute('tabindex'));
  platzMessen();
  haltSetzen();
  document.fonts.ready.then(platzMessen);
  window.addEventListener('resize', () => { platzMessen(); haltSetzen(); });
  galerie.addEventListener('scroll', zeigen, { passive: true });
  zeigen();
}

// Großansicht: Die Galeriebilder sind Verweise auf die große Bilddatei. Mit
// JavaScript öffnen sie stattdessen ein Dialogfenster (Esc schließt, Pfeile
// blättern, der Fokus kehrt zum Auslöser zurück).
const lupe = document.querySelector('.lupe');
if (lupe && galerie && lupe.showModal) {
  // Nur Bilder öffnen die Großansicht; Videos haben eigene Bedienelemente
  const verweise = [...galerie.querySelectorAll('a.galerie__bild')];
  const flaeche = lupe.querySelector('.lupe__flaeche');
  const bild = flaeche.querySelector('img');
  const quelle = flaeche.querySelector('source');
  let stelle = 0;
  const maus = matchMedia('(hover: hover)').matches;
  const nah = (an) => {
    flaeche.setAttribute('aria-pressed', String(an));
    flaeche.setAttribute('aria-label', an ? texte.bildVerkleinern : texte.bildVergroessern);
    lupe.querySelector('.lupe__hinweis').textContent = maus
      ? (an ? texte.klickVerkleinert : texte.klickVergroessert)
      : (an ? texte.tippenVerkleinert : texte.tippenVergroessert);
    // Ein Bildpunkt je Gerätepunkt: schärfer wird es nicht, größer wäre hochgerechnet
    bild.style.width = an ? `${bild.naturalWidth / devicePixelRatio}px` : '';
  };
  const zeige = (nummer) => {
    stelle = (nummer + verweise.length) % verweise.length;
    nah(false);
    quelle.removeAttribute('srcset');
    bild.src = verweise[stelle].dataset.gross;
    bild.alt = verweise[stelle].querySelector('img').alt;
    lupe.querySelector('.lupe__zaehler').textContent = `${stelle + 1} / ${verweise.length}`;
  };
  verweise.forEach((verweis, nummer) => {
    verweis.addEventListener('click', (ereignis) => {
      ereignis.preventDefault();
      zeige(nummer);
      lupe.showModal();
      // Fokus aufs Fenster statt auf den ersten Knopf: Safari zeichnet sonst nach einem Tipp den Fokusrahmen
      lupe.focus();
    });
  });
  lupe.addEventListener('click', (ereignis) => {
    const knopf = ereignis.target.closest('[data-lupe]');
    if (!knopf) return;
    if (knopf.dataset.lupe === 'zu') lupe.close();
    if (knopf.dataset.lupe === 'zurueck') zeige(stelle - 1);
    if (knopf.dataset.lupe === 'weiter') zeige(stelle + 1);
    if (knopf.dataset.lupe === 'nah') {
      const an = flaeche.getAttribute('aria-pressed') !== 'true';
      // Tippstelle merken, damit die Vergrößerung dort landet, wo getippt wurde
      const rahmen = flaeche.getBoundingClientRect();
      const x = ereignis.detail ? (ereignis.clientX - rahmen.left) / rahmen.width : 0.5;
      const y = ereignis.detail ? (ereignis.clientY - rahmen.top) / rahmen.height : 0.5;
      nah(an);
      if (an) flaeche.scrollTo({ left: x * flaeche.scrollWidth - rahmen.width / 2, top: y * flaeche.scrollHeight - rahmen.height / 2, behavior: 'instant' });
    }
  });
  lupe.addEventListener('keydown', (ereignis) => {
    if (ereignis.key === 'ArrowLeft') zeige(stelle - 1);
    if (ereignis.key === 'ArrowRight') zeige(stelle + 1);
  });
  lupe.addEventListener('close', () => {
    // Galerie auf das zuletzt gezeigte Bild stellen, Fokus zurück an den Auslöser
    galerie.scrollTo({ left: verweise[stelle].offsetLeft - galerie.offsetLeft, behavior: 'instant' });
    verweise[stelle].focus({ preventScroll: galerie.scrollWidth > galerie.clientWidth });
  });
}

// Fester Kaufbalken nur, solange weder der Hauptknopf noch die offene
// Beratungsanfrage im Bild ist
const hauptknopf = document.querySelector('#kaufen');
const balken = document.querySelector('.kaufbalken');
if (hauptknopf && balken && 'IntersectionObserver' in window) {
  const imBild = new Set();
  const waechter = new IntersectionObserver((eintraege) => {
    eintraege.forEach((eintrag) => {
      if (eintrag.isIntersecting) imBild.add(eintrag.target);
      else imBild.delete(eintrag.target);
    });
    balken.toggleAttribute('data-aus', imBild.size > 0);
  });
  waechter.observe(hauptknopf);
  const ratInhalt = document.querySelector('.rat__inhalt');
  if (ratInhalt) waechter.observe(ratInhalt);
}


// Sprungmarke auf eine Klappe (z. B. #haendler in den Fragen): aufklappen,
// beim Laden und bei Klick auf einen Verweis auf derselben Seite.
function klappeZumAnker() {
  const ziel = location.hash && document.getElementById(location.hash.slice(1));
  if (ziel && ziel.tagName === 'DETAILS' && !ziel.classList.contains('rat')) {
    ziel.open = true;
    ziel.scrollIntoView({ block: 'start' });
  }
}
klappeZumAnker();
window.addEventListener('hashchange', klappeZumAnker);


// Cookie-Einstellungen in der Fußzeile: öffnet Shopifys Einwilligungsfenster,
// damit eine Einwilligung so leicht widerrufen werden kann, wie sie erteilt wurde.
// Ohne Banner-Skript bleibt der Knopf verborgen.
const cookieKnopf = document.querySelector('[data-cookie-einstellungen]');
if (cookieKnopf) {
  const zeigen = () => { if (window.privacyBanner) cookieKnopf.hidden = false; };
  zeigen();
  window.addEventListener('load', zeigen);
  cookieKnopf.addEventListener('click', () => window.privacyBanner && window.privacyBanner.showPreferences());
}

// ---------- Bewertungen (Judge.me): Datum „21.06.2026“ statt „21/06/2026“ auf Deutsch (Produktseite 03.11.2026, Punkt 3)
// Judge.me schreibt die Daten erst nach dem Laden und beim Blättern hinein, daher ein Beobachter.
const bewertungen = document.querySelector('.jdgm-rev-widg');
if (bewertungen && document.documentElement.lang.startsWith('de')) {
  const punkte = () => bewertungen.querySelectorAll('.jdgm-rev__timestamp').forEach(t => {
    if (t.textContent.includes('/')) t.textContent = t.textContent.replaceAll('/', '.');
  });
  new MutationObserver(punkte).observe(bewertungen, { childList: true, subtree: true });
  punkte();
}
